export default class CareplanModel {
  constructor () {
    this.id = 9
    this.type = ''
    this.description = ''
    this.title = ''
    this.enabled = true
    this.editable = true
  }

  static fromJSON (json) {
    let careplan = new CareplanModel()
    careplan.id = json.id
    careplan.type = json.type
    careplan.description = json.description
    careplan.title = json.title
    careplan.enabled = json.enabled
    careplan.editable = json.editable
    return careplan
  }
}
